import React, { useState } from 'react';
import { Tabs } from 'antd';
import { t } from '../../../i18n/i18n';
import AdditionalQuestionsCatalog from './AdditionalQuestionsCatalog';
import SubskillsQuestionsCatalog from './SubskillsQuestionsCatalog';
import './AdditionalQuestionsWithTabs.scss';

const { TabPane } = Tabs;

export default function AdditionalQuestionsWithTabs({
  additionalQuestions,
  customTestGroup,
  onAddQuestion,
  onDeleteQuestion,
  onEditQuestion,
  onSearchQuestions,
  onClearSearch,
  onShowAddQuestion,
  onTabChange,
}) {
  const [activeTab, setActiveTab] = useState('workspace');

  const handleTabChange = (key) => {
    setActiveTab(key);
    // Llamar al handler del componente padre para limpiar formularios
    if (onTabChange) {
      onTabChange(key);
    }
  };

  return (
    <div className="additional-questions-tabs">
      <Tabs
        activeKey={activeTab}
        onChange={handleTabChange}
        type="card"
        size="large"
        className="mb-3"
      >
        <TabPane
          tab={
            <span className="font-weight-500">
              {t('WORKSPACE_QUESTIONS_TAB')}
            </span>
          }
          key="workspace"
        >
          <AdditionalQuestionsCatalog
            additionalQuestions={additionalQuestions}
            customTestGroup={customTestGroup}
            onAddQuestion={onAddQuestion}
            onDeleteQuestion={onDeleteQuestion}
            onEditQuestion={onEditQuestion}
            onSearchQuestions={onSearchQuestions}
            onClearSearch={onClearSearch}
            onShowAddQuestion={onShowAddQuestion}
          />
        </TabPane>
        <TabPane
          tab={
            <span className="font-weight-500">
              {t('SUBSKILLS_QUESTIONS_TAB')}
            </span>
          }
          key="subskills"
        >
          <SubskillsQuestionsCatalog
            customTestGroup={customTestGroup}
            onAddQuestion={onAddQuestion}
          />
        </TabPane>
      </Tabs>
    </div>
  );
}
